import { HttpInterceptorFn } from '@angular/common/http';

export const withCredInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req.clone({ withCredentials: true }));
};
